import type { BattleInfo } from '@boss/shared'

const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="currentColor">
    <path d="M20.317 4.37a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.865-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.74 19.74 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.058a.082.082 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
)
const XIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)

/** Mini banner above the artwork: a call to action into the gacha, plus community links. */
export function BattleLinks({ ui }: { ui: BattleInfo['ui'] }) {
  const { links } = ui
  const social = [
    links.discord ? { href: links.discord, label: 'Discord', icon: <DiscordIcon /> } : null,
    links.twitter ? { href: links.twitter, label: 'X', icon: <XIcon /> } : null,
  ].filter((x): x is NonNullable<typeof x> => x !== null)
  if (!links.gacha && !links.explainer && social.length === 0) return null
  return (
    <nav className="battle-links" aria-label="Battle links">
      {links.gacha && ui.joinText ? (
        <a className="battle-join" href={links.gacha} target="_blank" rel="noopener">
          {ui.joinText} <span aria-hidden="true">→</span>
        </a>
      ) : null}
      {links.explainer && ui.explainerText ? (
        <a className="battle-explainer" href={links.explainer} target="_blank" rel="noopener">
          {ui.explainerText} <span aria-hidden="true">↗</span>
        </a>
      ) : null}
      {social.length > 0 ? (
        <span className="battle-tactics">
          {ui.tacticsText ? <span className="battle-tactics-text">{ui.tacticsText}</span> : null}
          {social.map((s) => (
            <a key={s.label} className="battle-social" href={s.href} target="_blank" rel="noopener" aria-label={s.label} title={s.label}>
              {s.icon}
            </a>
          ))}
        </span>
      ) : null}
    </nav>
  )
}
